import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  ModalFooter,
} from 'reactstrap';
import classnames from 'classnames';
import Dip from './Dip';
import Storage from './Storage';
import Listing from './Listing';
import './index.css';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import WarningModal from '../../../../components/WarningModal';
import { useDispatch } from 'react-redux';
import { getStateCodes } from '../../../../actions/ProposalsEditor';
let tabs = [
  { value: 'CNAM Dip', tab: 'dip' },
  { value: 'CNAM Storage', tab: 'storage' },
  { value: 'Direct Listing', tab: 'listing' },
];
const STORAGE_FORM = {
  callerId: '',
  selectedNumbers: [],
};
const LISTING_NONEMPTY_FEILDS = [
  'businessName',
  'firstName',
  'streetName',
  //   'location',
  'city',
  'state',
];
const LISTING_FORM = {
  businessName: '',
  firstName: '',
  streetNo: '',
  streetPreDirection: '',
  streetName: '',
  streetType: '',
  streetPostDirection: '',
  location: '',
  city: '',
  state: '',
  zip: '',
  selectedNumbers: [],
};
function PortingCNAM({ numbers, onStepBack, onStepNext, features = {} }) {
  const [selected, setSelected] = useState('dip');
  const history = useHistory();
  const dispatch = useDispatch()
  const [warning, setWarning] = useState(false);
  const [dip, setDip] = useState(() => {
    let cnamDip = features.callerId && features.callerId.cnamDip
    return {
      unSelectedNumbers: cnamDip == "Y" ? [] : numbers,
      selectedNumbers: cnamDip == "Y" ? numbers : [],
      unSelectedSelection: [],
      selectedSelection: [],
      selection: cnamDip == "Y" ? "selection" : 'all',    //all|selection
    }
  })

  const [storage, setStorage] = useState(() => {
    let callingName = features.callerId && features.callerId.callingName
    let form = {
      callerId: callingName,
      selectedNumbers: numbers
    }
    return {
      numbers: callingName ? [] : numbers,
      data: callingName ? [form] : [{ ...STORAGE_FORM }],
      allNumbers: numbers,
      FORM: STORAGE_FORM,
    }
  });
  const [listing, setListing] = useState(() => {
    let directoryListing = features.directoryListing || {}
    const isAdded = !!directoryListing.firstName
    let data = {
      businessName: directoryListing.lastName,
      firstName: directoryListing.firstName,
      streetNo: directoryListing.streetNum,
      streetPreDirection: directoryListing.streetPreDir,
      streetName: directoryListing.streetName,
      streetType: directoryListing.streetType,
      streetPostDirection: directoryListing.streetPostDir,
      location: directoryListing.location,
      city: directoryListing.city,
      state: directoryListing.state,
      zip: directoryListing.postalCode,
      selectedNumbers: numbers,
    }
    return {
      numbers: isAdded ? [] : numbers,
      data: isAdded ? [data] : [{ ...LISTING_FORM }],
      allNumbers: numbers,
      FORM: STORAGE_FORM,
    }
  });
  useEffect(() => {
    dispatch(getStateCodes(localStorage.getItem('jwtToken')))
  }, [])
  const GetNavItem = ({ tab, value }) => {
    return (
      <NavItem>
        <NavLink onClick={() => setSelected(tab)} className={classnames({ active: selected === tab })}>{value}</NavLink>
      </NavItem>
    );
  };
  const onNext = () => {
    // let index = tabs.findIndex(item => item.tab === selected);
    let errorFeilds = [];
    let data = {};
    numbers.map(num => {
      data[num] = { tn: num };
    });
    if (dip.selection == 'all') numbers.map(num => (data[num].dip = 'N'));
    else dip.selectedNumbers.map(num => (data[num].dip = 'Y'));
    storage.data.map(item => {
      item.selectedNumbers.map(num => (data[num].callerId = item.callerId));
    });
    listing.data.map(item => {
      item.selectedNumbers.map(num => (data[num].listing = item));
    });
    if (selected == 'storage') {
      storage.data.map((item, index) => {
        Object.entries(item).map(([key, value]) => {
          if (key == 'callerId' && (!value || value.length > 15)) {
            if (!value)
              errorFeilds.push({ feildName: key, error: 'Field Cannot Be Empty!', index });
            else
              errorFeilds.push({
                feildName: key,
                error: 'Caller ID (LIDB) must be less than or equal to 15 character!',
                index,
              });
          } else if (!value.length)
            errorFeilds.push({ feildName: key, error: 'Please select numbers!', index });
        });

      });
    }
    if (selected == 'listing') {
      listing.data.map((item, index) => {
        Object.entries(item).map(([key, value]) => {
          if (LISTING_NONEMPTY_FEILDS.includes(key) && !value.trim())
            errorFeilds.push({ feildName: key, error: 'Field Cannot Be Empty!', index });
          if (key == 'streetNo' && (!value || !Number(value)))
            errorFeilds.push({ feildName: key, error: 'Please enter valid street number!', index });
          if (key == 'zip' && (!Number(value) || value.length < 5 || value.length > 10))
            errorFeilds.push({
              feildName: key,
              error: 'Zip Code must be of 5 to 10 length!',
              index,
            });
          if (key === 'selectedNumbers' && !value.length)
            errorFeilds.push({ feildName: key, error: 'Please Select Numbers!', index });
        });
      });
    }
    if (errorFeilds.length) {
      const errorElements = document.querySelectorAll('.error-message');
      errorElements.forEach(box => {
        box.remove();
      });
      errorFeilds.map(item => {
        let parr = document.createElement('p');
        parr.setAttribute('class', 'error-message');
        parr.setAttribute('name', 'error-message');
        parr.innerHTML = item.error;
        let consoleLine = document.getElementById(`${item.feildName}${item.index}`);
        consoleLine && consoleLine.insertAdjacentElement('afterend', parr);
      });
      toast.error('Please fixed the errors!');
      return;
    }
    // if (!tabs[index + 1])
    return onStepNext(Object.values(data));
    // setSelected(tabs[index + 1].tab);
  };
  const onCancel = () => {
    setWarning(false);
    history.push('/provisioning/porting');
  };
  const onBack = () => {
    // let index = tabs.findIndex(item => item.tab === selected);
    // if (index <= 0)
    return onStepBack();
    // setSelected(tabs[index - 1].tab);
  };
  return (
    <div className="p-4">
      <div className="h5 font-weight-bold w-100 pt-3 text-primary">
        Order Port In (Update Features)
      </div>
      <Col sm={6}>
        <Nav tabs>
          {tabs.map(props => (
            <GetNavItem key={props.tab} {...props} />
          ))}
        </Nav>
      </Col>
      <Col className={'scroll-bar-highted'} sm={12}>
        <TabContent activeTab={selected}>
          <TabPane tabId="dip">
            <Dip
              {...dip}
              defaultValues={features.callerId}
              setSelection={selection => setDip(dip => ({ ...dip, selection }))}
              setSelectedNumbers={selectedNumbers => setDip(dip => ({ ...dip, selectedNumbers }))}
              setSelectedSelection={selectedSelection =>
                setDip(dip => ({ ...dip, selectedSelection }))
              }
              setUnSelectedNumbers={unSelectedNumbers =>
                setDip(dip => ({ ...dip, unSelectedNumbers }))
              }
              setUnSelectedSelection={unSelectedSelection =>
                setDip(dip => ({ ...dip, unSelectedSelection }))
              }
            />
          </TabPane>

          <TabPane tabId="storage">
            <Storage
              {...storage}
              setData={data => setStorage(s => ({ ...s, data }))}
              setNumbers={numbers => setStorage(s => ({ ...s, numbers }))}
            />
          </TabPane>

          <TabPane tabId="listing">
            <Listing
              {...listing}
              LISTING_FORM={LISTING_FORM}
              setData={data => setListing(l => ({ ...l, data }))}
              setNumbers={numbers => setListing(l => ({ ...l, numbers }))}
            />
          </TabPane>
        </TabContent>
      </Col>
      <Row style={{ marginTop: 10 }}>
        <Col
          className={'d-flex justify-content-between align-items-center w-100'}
          md={{ offset: 8, size: 2 }}
        >
          <Button onClick={onBack} outline color="primary">
            {features ? "Cancel" : "Back"}
          </Button>
          {!features && <Button onClick={() => setWarning(true)} outline color="primary">
            Cancel
          </Button>}
          <Button onClick={onNext} color="primary">
            {features ? "Save" : "Next"}
          </Button>
        </Col>
      </Row>
      <WarningModal
        isOpen={warning}
        onConfirm={onCancel}
        onCancel={() => setWarning(false)}
        yesButtonText="Yes, I'm Sure"
        noButtonText={'No, Stay here'}
        title="Warning"
        body={`You are about to leave this page. Any work up to this point will be lost.${'\n'}Are you sure you want to proceed`}
      />
    </div>
  );
}

export default PortingCNAM;
